import { lazy } from "react"
import { IUpgradeCost } from "store/apis/bossAPI/boss.types"
import { IArenaCyclePendingReward } from "store/apis/bossArenaCycleAPI"

export const BOSS_MODALS = {
  bossUpgradeConfirm: {
    component: lazy(() => import("modals/ui/boss/boss-upgrade-confirm-modal")),
    params: {} as {
      skillName: string
      linkedSkillName?: string
      cost: IUpgradeCost
      runeRequired: boolean
      runeLevel?: number
      runeCount?: number
      runeImgSrc?: string
      onConfirm: () => Promise<void> | void
    }
  },
  bossSkillInfo: {
    component: lazy(() => import("modals/ui/boss/boss-skill-info-modal")),
    params: {} as {
      name: string
      icon: string
      level: number
      personal: string
      clan: string
      set: string
      elixir?: string
      altar?: string
      currentEffect: string
    }
  },
  bossInfo: {
    component: lazy(() => import("modals/ui/boss/boss-info-modal"))
  },
  bossLogs: {
    component: lazy(() => import("modals/ui/boss/boss-logs-modal")),
    params: {} as { mode?: "boss" | "pvp" }
  },
  findArenaOpponent: {
    component: lazy(() => import("modals/ui/boss/find-arena-opponent-modal")),
    params: {} as { onDecline?: () => void }
  },
  resetParametersConfirm: {
    component: lazy(
      () => import("modals/ui/boss/reset-parameters-confirm-modal")
    ),
    params: {} as {
      onConfirm: () => Promise<void> | void
      nextResetCost: { value: number; currency: string } | null
      intervalHours: number
      nextAvailableAt: string | null
      isFirstFreeReset?: boolean
    }
  },
  arenaCycleResult: {
    component: lazy(() => import("modals/ui/boss/arena-cycle-result-modal")),
    params: {} as { pending: IArenaCyclePendingReward }
  },
  arenaCycleInfo: {
    component: lazy(() => import("modals/ui/boss/arena-cycle-info-modal"))
  },
  bossSeasonInfo: {
    component: lazy(() => import("modals/ui/boss/boss-season-info-modal"))
  },
  bossAbilityInfo: {
    component: lazy(() => import("modals/ui/boss/boss-ability-info-modal")),
    params: {} as {
      icon: string
      titleKey: string
      descriptionKey: string
      descriptionValues: Record<string, string | number>
      activatable?: boolean
      activateCost?: number
      hideBorder?: boolean
    }
  }
} as const
